module.exports = __webpack_public_path__ + "static/media/img3.20a2ecf7.jpg";